// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1ecoZ","headerTitle":"styles_headerTitle__3-Hg6","svg":"styles_svg__2-suN","svghover":"styles_svghover__2LL46"};